import { useContext, useState } from "react";
import { VAR_LIMIT } from "../../../../config/constant";
import { getDateFormat } from "../../../../helpers/helper";
import { patchPatient } from "../../../../services/httpService/patientRequest";
import { updatePatientValidator } from "../../../../validators/PatientValidator";
import { GlobalContext } from "../../../contexts/globalContext";
import InputText from "../../atoms/InputText/InputText";
import Modal from "../../atoms/Modal/Modal";

let minDate = new Date();
minDate = minDate.setFullYear(minDate.getFullYear() - VAR_LIMIT.age.max);
minDate = getDateFormat(minDate);

const maxDate = getDateFormat(new Date());

const ModalPatientEdit = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [state, setState] = useState({
    dateOfBirth: props.patient.profile.dateOfBirth
      ? getDateFormat(props.patient.profile.dateOfBirth)
      : "",
    weight: props.patient.profile.weight || "",
    height: props.patient.profile.height || "",
  });

  const handleChange = (e) => {
    let { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleClose = () => {
    setState({
      dateOfBirth: props.patient.profile.dateOfBirth
        ? getDateFormat(props.patient.profile.dateOfBirth)
        : "",
      weight: props.patient.profile.weight || "",
      height: props.patient.profile.height || "",
    });
    if (props.handleClose) props.handleClose();
  };

  const handleSubmit = async () => {
    try {
      let data = {
        weight: state.weight,
        height: state.height,
        dateOfBirth: state.dateOfBirth ? state.dateOfBirth : undefined,
      };
      const { error } = await updatePatientValidator(data);
      if (error) throw new Error(error.details[0].message);

      dispatch("isLoading", true);

      await patchPatient({
        ...data,
        _id: props.patient._id,
        doctor: sharedState.user._id,
      });

      dispatch("isLoading", false);
      if (props.handleClose) props.handleClose();
      if (props.handleUpdate) props.handleUpdate();
    } catch (error) {
      dispatch("alert", {
        type: "warning",
        message: error.message,
        show: true,
      });
      dispatch("isLoading", false);
    }
  };

  return (
    <Modal
      show={props.show}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    >
      <div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Nama</div>
          <div
            type="text"
            className={
              "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-40 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg "
            }
          >
            {props.patient.name || ""}
          </div>
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Jenis Kelamin</div>
          <div
            type="text"
            className={
              "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-40 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg "
            }
          >
            {props.patient.profile.isMale ? "Laki-laki" : "Perempuan"}
          </div>
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Tanggal Lahir</div>
          <InputText
            type="date"
            className={"col-span-12 sm:col-span-9"}
            placeholder="yyyy-mm-dd"
            name="dateOfBirth"
            value={state.dateOfBirth}
            max={maxDate}
            min={minDate}
            onChange={handleChange}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Berat Badan (kg)</div>
          <InputText
            type="number"
            className={"col-span-12 sm:col-span-9 "}
            name="weight"
            placeholder="Berat Badan (kg)"
            value={state.weight}
            onChange={handleChange}
            min={VAR_LIMIT.weight.min}
            max={VAR_LIMIT.weight.max}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Tinggi Badan (cm)</div>
          <InputText
            type="number"
            className={"col-span-12 sm:col-span-9"}
            name="height"
            placeholder="Tinggi Badan (cm)"
            value={state.height}
            onChange={handleChange}
            min={VAR_LIMIT.height.min}
            max={VAR_LIMIT.height.max}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalPatientEdit;
